module.exports = __webpack_public_path__ + "static/media/temp_16.d9e4d04b.jpg";